import api from './api';

// User Management
export const getAllUsers = async (skip = 0, limit = 10, searchQuery = '') => {
  let url = `/api/admin/users?skip=${skip}&limit=${limit}`;
  if (searchQuery) {
    url += `&search=${encodeURIComponent(searchQuery)}`;
  }
  
  return await api.get(url);
};

export const getAllMentors = async () => {
  return await api.get('/api/admin/mentors');
};

export const getUsersCount = async (searchQuery = '') => {
  let url = `/api/admin/users_count`;
  if (searchQuery) {
    url += `?search=${encodeURIComponent(searchQuery)}`;
  }
  
  return await api.get(url);
};

export const getUserDetails = async (userId) => {
  return await api.get(`/api/admin/users/${userId}`);
};

export const updateUserMembership = async (userId, membershipType) => {
  return await api.patch(`/api/admin/users/${userId}/membership`, {
    membership_type: membershipType
  });
};

export const giftCreditsToUser = async (userId, credits) => {
  return await api.post(`/api/admin/users/${userId}/gift-credits`, {
    credits: credits
  });
};

export const deleteUser = async (userId) => {
  return await api.delete(`/api/admin/users/${userId}`);
};

export const assignUserToMentor = async (userId, mentorId) => {
  return await api.post(`/api/admin/users/${userId}/assign-mentor`, {
    mentor_id: mentorId
  });
};

// Ticket Management
export const getAllTickets = async (skip = 0, limit = 50, status = '') => {
  let url = `/api/admin/tickets?skip=${skip}&limit=${limit}`;
  if (status) {
    url += `&status=${status}`;
  }
  return await api.get(url);
};

export const getTicketDetails = async (ticketId) => {
  return await api.get(`/api/admin/tickets/${ticketId}`);
};

export const updateTicket = async (ticketId, data) => {
  return await api.patch(`/api/admin/tickets/${ticketId}`, data);
};

// Mentor Settings Management
export const getMentorSettings = async (mentorId) => {
  return await api.get(`/api/admin/mentors/${mentorId}/settings`);
};

export const updateMentorSettings = async (mentorId, settings) => {
  return await api.patch(`/api/admin/mentors/${mentorId}/settings`, settings);
};

// Admin Dashboard Statistics
export const getAdminStats = async () => {
  return await api.get('/api/admin/stats');
};